<template>
  <div>
    <!-- 遮罩层 -->
    <transition name="fade">
      <div
        v-if="visible"
        class="dialog-overlay"
        @click="handleOverlayClick"
      ></div>
    </transition>

    <!-- 弹窗 -->
    <transition name="pop">
      <div v-if="visible" class="dialog-container">
        <div class="dialog-content" @click.stop>
          <!-- 关闭按钮 -->
          <button class="close-btn" @click="close">
            <img src="../../../assets/shop/pop/close.png" alt="" />
          </button>

          <!-- 抽奖标题 -->
          <div class="dialog-title" v-if="point > 0">
            {{ $t("drawDialog.congratulations") }}
          </div>
          <div class="dialog-title" v-else>{{ $t("drawDialog.draw1") }}</div>

          <!-- 弹出gif动画 -->
          <div v-if="showPopGif" class="pop-gif-wrapper">
            <img
              src="../../../assets/shop/pop.gif"
              alt=""
              class="pop-gif-item"
            />
          </div>

          <!-- 奖品展示 -->
          <div class="dialog-body">
            <div class="rewards-list">
              <!-- 奖品列表 -->
              <template>
                <div
                  v-for="(item, index) in rewards"
                  :key="index"
                  class="reward-item"
                >
                  <!-- 奖品图片 -->
                  <div
                    class="reward-image"
                    :class="{ 'gold-reward': item.id === 7 || item.id === 9 }"
                  >
                    <img v-if="item.img" :src="item.img" alt="" />
                  </div>

                  <!-- 奖品名称 -->
                  <!-- <div class="reward-name">{{ item.name }}</div> -->
                </div>
              </template>
            </div>

            <div class="reward-point">
              <div v-if="point > 0">
                {{ $t("drawDialog.draw2") }} {{ point }}
                {{ $t("drawDialog.draw3") }}
              </div>
            </div>

            <!-- 确认按钮 -->
            <div class="reward-action">
              <el-button type="primary" size="large" @click="close">
                {{ $t("drawDialog.draw4") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DrawDialog",
  data() {
    return {
      visible: false,
      rewards: [], // 改为数组以支持多个奖品
      point: 0,
      showPopGif: false,
    };
  },
  methods: {
    /**
     * 打开弹窗并显示奖品
     * @param {Object} rewardData 奖品数据对象，包含 rewards 数组
     * @param {Number} point 积分
     */
    open(rewardData, point) {
      if (rewardData) {
        this.rewards = rewardData.rewards || [];
        this.point = point || 0;
        console.log(this.rewards, point);
      } else {
        this.rewards = [];
      }
      this.visible = true;
      // 只有当三次奖励数值都相同或包含id为9时才显示gif动画
      const isTripleSame =
        this.rewards &&
        Array.isArray(this.rewards) &&
        this.rewards.length >= 3 &&
        this.rewards[0].id === this.rewards[1].id &&
        this.rewards[1].id === this.rewards[2].id;

      const hasId9 =
        this.rewards &&
        Array.isArray(this.rewards) &&
        this.rewards.some((item) => item && item.id === 9);

      if (point > 0 && (isTripleSame || hasId9)) {
        this.showPopGif = true;
        setTimeout(() => {
          this.showPopGif = false;
        }, 4000);
      }
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.visible = false;
    },
    /**
     * 处理遮罩层点击
     */
    handleOverlayClick() {
      // 如果需要点击遮罩层关闭弹窗，取消注释下一行
      // this.close();
    },
  },
};
</script>

<style scoped lang="scss">
// 遮罩层
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

// 弹窗容器
.dialog-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

// 弹窗内容
.dialog-content {
  background-image: url(../../../assets/shop/pop/draw_bg.png);
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 38vw;
  height: 37vw;
  position: relative;
  padding: 12vw 3vw 2vw 2vw;
  box-sizing: border-box;
}

// 关闭按钮
.close-btn {
  position: absolute;
  top: 0vw;
  right: 0vw;
  width: 4vw;
  height: 4vw;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &:hover {
    transform: scale(1.1);
  }
}

// 标题
.dialog-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

// 内容
.dialog-body {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

// 奖品列表容器
.rewards-list {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0px;
  margin-bottom: 20px;
}

// 单个奖品项
.reward-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

// 奖品图片
.reward-image {
  width: 8vw;
  height: 8vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(../../../assets/shop/pop/draw_gift.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  overflow: hidden;
  padding: 1vw;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.reward-image.gold-reward {
  background-image: url(../../../assets/shop/pop/draw_gift_gold.gif);
}

// 奖品名称
.reward-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  text-align: center;
}
.reward-point {
  width: 100%;
  height: 2vw;
  line-height: 2vw;
  text-align: center;
  color: #000;
  font-size: 24px;
}
// 奖品操作
.reward-action {
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 2vw;
  position: relative;
  z-index: 1;

  .el-button {
    width: 12vw;
  }
}

// 弹出动画
.pop-enter-active {
  animation: popIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.pop-leave-active {
  animation: popOut 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
  from {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes popOut {
  from {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 弹出gif动画样式 */
.pop-gif-wrapper {
  position: absolute;
  top: 0vw;
  left: 0;
  width: 38vw;
  height: 38vw;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: slideInRight 0.3s ease-out;
}

.pop-gif-item {
  width: 100%;
  height: 100%;
  object-fit: contain;
  animation: popInAnimation 0.3s ease-out;
}

@keyframes popInAnimation {
  from {
    opacity: 0;
    transform: scale(0.3);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 1024px) {
  .dialog-content {
    width: 90vw;
    height: 90vw;
    padding: 30vw 6vw 6vw 5vw;
  }
  .reward-image {
    width: 22vw;
    height: 22vw;
  }
  .reward-name {
    font-size: 12px;
  }
  .rewards-list {
    gap: 12px;
  }
  .close-btn {
    width: 10vw;
    height: 10vw;
  }
  .reward-action {
    margin-top: 4vw;
    .el-button {
      width: 30vw !important;
    }
  }
  .dialog-title {
    font-size: 14px !important;
    margin-bottom: 10px;
  }
  .pop-gif-wrapper {
    width: 90vw;
    height: 90vw;
  }
  .reward-point {
    font-size: 14px;
  }
}
</style>

